export default __webpack_public_path__ + "static/media/41.c9c93f30.jpg";